import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import AppRouter from "./router";

import "./icons";
import "./components";

Vue.config.productionTip = false;

Vue.use(VueRouter);

new Vue({
  render: (h) => h(App),
  router: AppRouter,
}).$mount("#app");
